import * as React from "react";
const SvgFiRrFaceNauseated = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-nauseated_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M7 11.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 11.5m10 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17 11.5m-.333 4.245c-.174.158-.667.727-.667 1.255s.495 1.098.667 1.256a1.002 1.002 0 0 1-.672 1.743 1 1 0 0 1-.659-.25c-.104-.092-.826-.762-1.163-1.749h-4.35c-.337.987-1.058 1.657-1.163 1.749a1 1 0 0 1-1.412-.086 1 1 0 0 1 .086-1.412c.168-.153.663-.722.663-1.251s-.495-1.098-.667-1.256c-.407-.369-.441-1-.074-1.409a.996.996 0 0 1 1.404-.084c.104.092.826.762 1.163 1.749h4.35c.337-.987 1.058-1.657 1.163-1.749a1 1 0 0 1 1.331 1.494m2.294-6.471a1 1 0 0 1-1.236.688c-1.404-.401-2.793-1.336-3.54-2.381a1 1 0 0 1 1.628-1.163c.484.678 1.496 1.344 2.46 1.619a1 1 0 0 1 .687 1.236zm-12.687.688a1 1 0 0 1-.549-1.924c.965-.275 1.977-.941 2.46-1.619a1 1 0 1 1 1.628 1.163c-.746 1.045-2.135 1.979-3.54 2.381z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-nauseated_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceNauseated;
